import {
  CHECK_USER_PROFILE_ONCE_A_DAY_KEY,
  LATEST_UPDATE_AT_KEY,
} from "@/constants/system_updates";
import * as types from "@/modules/account/store/types";

export const checkUpdatesOnceADay = (store) => {
  const lastTriggered = localStorage.getItem(CHECK_USER_PROFILE_ONCE_A_DAY_KEY);
  const today = new Date().toISOString().split("T")[0];
  if (lastTriggered !== today) {
    localStorage.setItem(CHECK_USER_PROFILE_ONCE_A_DAY_KEY, today);
    if (lastTriggered) {
      store.dispatch(types.GET_USER_DATA);
    }
  }
};

export const shouldUpdate = (latestReleaseAt) => {
  if (!latestReleaseAt) {
    return false;
  }
  const latestReleaseAtDate = new Date(latestReleaseAt);
  if (isNaN(latestReleaseAtDate.getTime())) {
    return false;
  }
  const storedLatestUpdateAt = localStorage.getItem(LATEST_UPDATE_AT_KEY);
  if (!storedLatestUpdateAt) {
    localStorage.setItem(LATEST_UPDATE_AT_KEY, latestReleaseAt);
    return false;
  }
  if (new Date(storedLatestUpdateAt) < latestReleaseAtDate) {
    localStorage.setItem(LATEST_UPDATE_AT_KEY, latestReleaseAtDate);
    return true;
  }
  return false;
};
